import './Login.scss';
import { ReactNode } from 'react';
import { Alert } from 'react-bootstrap';
import { Button } from '@Components/Button';
import { Size } from '@Components/designConstants';

// The boot-time session check couldn't get an answer (the sign-in service or /me was unreachable or
// errored). Reuses the login page's layout. It never signs the user out or reloads on its own.

interface AuthUnavailableViewProps {
  onRetry: () => void;
}

/** The session is untouched; retry re-runs the whole check. */
export const AuthUnavailableView = ({ onRetry }: AuthUnavailableViewProps): ReactNode => (
  <div className='bpm-login' data-testid='auth-unavailable'>
    <div className='bpm-login-inner'>
      <div className='login-form'>
        <Alert variant='warning'>
          Sign-in is temporarily unavailable, so we couldn&apos;t check your session. Your session
          has not been ended. Please try again in a moment.
        </Alert>
        <Button size={Size.LG} onClick={onRetry} data-testid='auth-unavailable-retry'>
          Try again
        </Button>
      </div>
    </div>
  </div>
);
